import React, { useContext } from "react";
import "./LinkExpired.css";
import { ExpiredLinkContext } from "../LinkExpiredView";
import Expired from "../../../../assests/images/expiredImage.svg";
import PlanButton from "../../../../components/ButtonComponent/PlanButton";

const LinkExpired = ({ textContents }) => {
  const { errorMessage, goBack } = useContext(ExpiredLinkContext);
  
  return (
    <div>
      <div className="expiredBox">
        <div className="col-xl-5 col-md-6 col-sm-6 col-12 boxCenterExpired">
          <img src={Expired} className="logoExpired" />
          <h5 className="mt-5 titleExpired">{textContents.linkExpired}</h5>
          <div className="messageExpired">
            <p className="textExpired">{errorMessage}</p>
          </div>
          <PlanButton
              text={textContents.goBack}
              onClick={goBack}
              style={{width:'120px'}}
            />
        </div>
      </div>
    </div>
  );
};

export default LinkExpired;
